<template lang="pug">
.card-edital
  .card-edital__header
    .card-edital__header-main
      .card-edital__icon-wrap
        img.card-edital__icon(
          src="@/assets/icons/editais/clipboard-list.svg"
          alt=""
        )
      .card-edital__heading
        h3.card-edital__title {{ titulo }}
        p.card-edital__subtitle {{ subtitulo }}
    span.card-edital__badge(:class="badgeClass") {{ badgeLabel }}

  p.card-edital__description {{ descricao }}

  hr.card-edital__separator

  .card-edital__info-grid
    .card-edital__info-item(v-for="item in infoItems" :key="item.label")
      span.card-edital__info-label {{ item.label }}
      span.card-edital__info-value(
        :class="{ 'card-edital__info-value--highlight': item.highlight, 'card-edital__info-value--danger': item.danger, 'card-edital__info-value--success': item.success }"
      ) {{ item.value }}

  hr.card-edital__separator

  .card-edital__actions
    button.card-edital__button.card-edital__button--ghost(
      v-if="!modoHistorico"
      type="button"
      @click="$emit('como-funciona')"
    )
      i.fas.fa-question-circle
      span Como funciona?
    button.card-edital__button.card-edital__button--outline(type="button" @click="$emit('download')")
      i.fas.fa-file-download
      span Baixar edital (PDF)
    button.card-edital__button.card-edital__button--primary(
      v-if="!modoHistorico"
      type="button"
      :disabled="!inscricoesAbertas"
      @click="$emit('inscricao')"
    )
      i.fas.fa-file-signature
      span Fazer a inscrição
</template>

<script>
export default {
  name: 'CardEdital',
  props: {
    titulo: {
      type: String,
      required: true
    },
    subtitulo: {
      type: String,
      default: ''
    },
    descricao: {
      type: String,
      default: ''
    },
    publicacao: {
      type: String,
      default: '-'
    },
    encerramentoInscricoes: {
      type: String,
      default: '-'
    },
    encerramentoAnalises: {
      type: String,
      default: '-'
    },
    modalidade: {
      type: String,
      default: '-'
    },
    vagas: {
      type: String,
      default: 'Não limitado'
    },
    inscricoesAbertas: {
      type: Boolean,
      default: false
    },
    modoHistorico: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    badgeLabel () {
      return this.inscricoesAbertas ? 'Inscrições abertas' : 'Inscrições encerradas'
    },
    badgeClass () {
      return this.inscricoesAbertas ? 'card-edital__badge--open' : 'card-edital__badge--closed'
    },
    infoItems () {
      return [
        { label: 'Publicação', value: this.publicacao },
        {
          label: this.inscricoesAbertas ? 'Encerramento das Inscrições' : 'Encerramento',
          value: this.encerramentoInscricoes,
          danger: true
        },
        {
          label: 'Encerramento das Analises',
          value: this.encerramentoAnalises,
          danger: true
        },
        { label: 'Modalidade', value: this.modalidade },
        { label: 'Vagas', value: this.vagas, success: true }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.card-edital {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  width: 100%;
}

.card-edital__header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
}

.card-edital__header-main {
  align-items: center;
  display: flex;
  flex: 1;
  gap: 24px;
  min-width: 0;
}

.card-edital__icon-wrap {
  align-items: center;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.card-edital__icon {
  display: block;
  height: 24px;
  width: 24px;
}

.card-edital__heading {
  min-width: 0;
}

.card-edital__title {
  color: #141414;
  font-family: 'Manrope', 'Ubuntu', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.55;
  margin: 0 0 4px;
}

.card-edital__subtitle {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.45;
  margin: 0;
}

.card-edital__badge {
  border-radius: 9999px;
  flex-shrink: 0;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.33;
  padding: 4px 8px;
  white-space: nowrap;

  &--open {
    background: #e9f5ec;
    color: #00a73d;
  }

  &--closed {
    background: #fee8e8;
    color: #e60007;
  }
}

.card-edital__description {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
  margin: 0;
  width: 100%;
}

.card-edital__separator {
  background: #eaeaea;
  border: 0;
  height: 1px;
  margin: 0;
  width: 100%;
}

.card-edital__info-grid {
  display: grid;
  gap: 16px 10px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  width: 100%;
}

.card-edital__info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.card-edital__info-label {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.33;
}

.card-edital__info-value {
  color: #141414;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;

  &--danger {
    color: #e60007;
  }

  &--success {
    color: #00a73d;
  }
}

.card-edital__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-end;
  width: 100%;
}

.card-edital__button {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 500;
  gap: 6px;
  height: 40px;
  line-height: 1.43;
  padding: 0 10px;
  transition: opacity 0.2s ease;

  i {
    font-size: 16px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &--ghost {
    color: #141414;
  }

  &--outline {
    background: #ffffff;
    border: 1px solid #eaeaea;
    color: #141414;
  }

  &--primary {
    background: #1e174e;
    color: #ffffff;
  }

  &:not(:disabled):hover {
    opacity: 0.9;
  }
}

@media (max-width: 1024px) {
  .card-edital__info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .card-edital__header {
    align-items: flex-start;
    flex-direction: column;
  }

  .card-edital__header-main {
    align-items: flex-start;
    flex-direction: column;
  }

  .card-edital__info-grid {
    grid-template-columns: 1fr;
  }

  .card-edital__actions {
    flex-direction: column;
  }

  .card-edital__button {
    justify-content: center;
    width: 100%;
  }
}
</style>
